import { BaseProxy } from "@/proxies/BaseProxy";

export class PagesProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `pages`,
      parameters,
    });
  }
}
export class PageProxy extends BaseProxy {
  constructor({ parameters = {} } = {}) {
    super({
      endpoint: `page`,
      parameters,
    });
  }
}

// /files -> dm/document modülüden liste veri çekecek (projectId ve categoryId filtrelerini alabilecek)
// /pages -> pages/page modülünden liste veri çekecek (projectId ve categoryId filtrelerini alabilecek)
// /page -> pages/page modülünden bir kayıdın detayını döndürecek (pageId parametre olarak alacak)